<template>
  <v-footer padless :fixed="$mq | mq({ sm: false, md: false, lg: true })">
    <v-card flat tile width="100%" class="primary text-center">
      <v-card-text class="white--text">
        <span class="mx-2">&copy; {{ new Date().getFullYear() }} — <i>SODA</i> by <a href="https://apjsoft.de" target="_blank" style="color:white"><strong>APJ Software UG</strong></a></span>
        <br class="hidden-md-and-up"/>
        <a href="" v-bind:class="loadImprint" @click="loadImprint" class="mx-2" style="color:white">Impressum</a>
        <br class="hidden-md-and-up"/>
        <a href="" v-bind:class="loadTerms" @click="loadTerms" class="mx-2" style="color:white">Allgemeine Vertragsbedingungen</a>
        <br class="hidden-md-and-up"/>
        <a href="" v-bind:class="loadPrivacy" @click="loadPrivacy" class="mx-2" style="color:white">Datenschutzerklärung</a>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: "ImprintFooterView",
  methods: {
    loadTerms(e) {
      e.stopPropagation();
      e.preventDefault();
      this.$router.push({ path: "/terms" });
    },
    loadPrivacy(e) {
      e.stopPropagation();
      e.preventDefault();
      this.$router.push({ path: "/privacy" });
    },
    loadImprint(e) {
      e.stopPropagation();
      e.preventDefault();
      this.$router.push({ path: "/imprint" });
    },
  },
};
</script>
